import { Svg, Path, Rect, Polygon } from "@react-pdf/renderer";

const Logo = (props) => (
    <Svg
        width="67.5"
        height="14.816"
        viewBox="0 0 67.5 14.816"
        {...props}
    >
        <Path
            d="m1.226,1.354h12.11v12.11H1.226V1.354ZM0,14.69h14.562V.128H0v14.562Z"
            fill="#1d1d1b"
        />
        <Path
            d="m60.677,8.705l1.531-6.616h.188l1.531,6.616h-3.25ZM63.903.128h-3.202l-3.37,14.561h1.961l1.068-4.616h3.884l1.068,4.616h2.188L63.903.128Z"
            fill="#1d1d1b"
        />
        <Polygon
            points="17.652 1.499 20.929 1.499 20.929 14.69 22.89 14.69 22.89 1.499 26.167 1.499 26.167 .128 17.652 .128 17.652 1.499"
            fill="#1d1d1b"
        />
        <Rect
            x="41.598"
            y=".129"
            width="1.961"
            height="14.561"
            fill="#1d1d1b"
        />
        <Path
            d="m54.353.937c-.345-.292-.761-.524-1.236-.688-.48-.165-1.008-.249-1.572-.249-.598,0-1.149.084-1.637.25-.485.164-.905.392-1.251.679-.34.28-.605.617-.79.999-.183.379-.275.797-.275,1.241v8.394c0,.634.118,1.159.353,1.56.24.41.548.743.918.992.376.253.807.435,1.281.54,1.111.245,2.149.209,2.976-.104.47-.178.885-.418,1.233-.713.343-.29.615-.632.808-1.017.19-.377.286-.779.286-1.194v-.599h-1.96v.407c0,.354-.066.66-.194.908-.128.249-.3.449-.509.594-.198.138-.418.238-.653.297-.223.056-.437.085-.638.085-.709,0-1.22-.195-1.519-.58-.279-.359-.421-.806-.421-1.326V3.619c0-.579.127-1.07.377-1.461.28-.437.815-.659,1.59-.659.593,0,1.076.195,1.434.578.353.379.533.833.533,1.349v.386h1.96v-.515c0-.473-.097-.916-.289-1.317-.193-.403-.464-.754-.805-1.043"
            fill="#1d1d1b"
        />
        <Path
            d="m35.473,5.296c-.06.342-.18.639-.358.882-.184.252-.448.446-.784.576-.318.124-.721.184-1.233.184h-1.837V1.499h1.708c.515,0,.943.056,1.271.167.353.121.636.313.84.571.2.252.332.556.393.904.055.311.083.673.083,1.077s-.028.767-.083,1.078m.1,2.405l.147-.078c.624-.333,1.072-.751,1.332-1.244.309-.58.465-1.293.465-2.118,0-2.781-1.412-4.133-4.316-4.133h-3.901v14.561h1.961v-6.372h1.369c1.63,0,2.089.748,2.296,1.756.038.185.947,4.616.947,4.616h1.956l-1.036-5.042c-.137-.67-.483-1.478-1.22-1.946"
            fill="#1d1d1b"
        />
    </Svg>
);

export default Logo;
